// Mock data for home page components

export interface Group {
  id: number;
  name: string;
  description: string;
  avatar: string;
  memberCount: number;
  jobCount: number;
  isJoined: boolean;
  category: string;
}

export interface Job {
  id: number;
  title: string;
  company: string;
  group: string;
  location: string;
  salary: string;
  type: string;
  postedBy: string;
  postedTime: string;
  isHot?: boolean;
  applicants: number;
}

export interface GroupActivity {
  group: string;
  activity: string;
  time: string;
  emoji: string;
}

export interface TrendingGroup {
  name: string;
  members: string;
  growth: string;
  emoji: string;
}

export interface GroupRecommendation {
  name: string;
  description: string;
  members: number;
  mutualMembers: number;
  emoji: string;
}

export interface GroupEvent {
  title: string;
  group: string;
  date: string;
  time: string;
  attendees: number;
  type: string;
}

export interface GroupInsight {
  metric: string;
  value: string;
  change: string;
}

// Public Groups Data - Manufacturing & Production Focus
export const publicGroups: Group[] = [
  {
    id: 1,
    name: "Công nghiệp May mặc",
    description: "Cộng đồng chuyên gia sản xuất thời trang và dệt may",
    avatar: "👗",
    memberCount: 24350,
    jobCount: 445,
    isJoined: false,
    category: "manufacturing",
  },
  {
    id: 2,
    name: "Nhà hàng & Khách sạn",
    description: "Ngành dịch vụ ăn uống và du lịch khách sạn",
    avatar: "🍽️",
    memberCount: 18720,
    jobCount: 623,
    isJoined: true,
    category: "hospitality",
  },
  {
    id: 3,
    name: "Chế biến Thực phẩm",
    description: "Sản xuất và chế biến thực phẩm an toàn",
    avatar: "🏭",
    memberCount: 15840,
    jobCount: 278,
    isJoined: false,
    category: "food_processing",
  },
  {
    id: 4,
    name: "Ô tô & Cơ khí",
    description: "Sản xuất linh kiện ô tô và máy móc công nghiệp",
    avatar: "🚗",
    memberCount: 22680,
    jobCount: 367,
    isJoined: true,
    category: "automotive",
  },
  {
    id: 5,
    name: "Điện tử & Linh kiện",
    description: "Sản xuất thiết bị điện tử và vi mạch",
    avatar: "🔌",
    memberCount: 19450,
    jobCount: 398,
    isJoined: false,
    category: "electronics",
  },
  {
    id: 6,
    name: "Xây dựng & Kiến trúc",
    description: "Thi công xây dựng và thiết kế kiến trúc",
    avatar: "🏗️",
    memberCount: 31200,
    jobCount: 512,
    isJoined: false,
    category: "construction",
  },
];

// Featured Jobs Data - Manufacturing Focus
export const featuredJobs: Job[] = [
  {
    id: 1,
    title: "Trưởng phân xưởng May",
    company: "Tập đoàn Dệt May Việt Nam",
    group: "Công nghiệp May mặc",
    location: "Bình Dương",
    salary: "18-28M VNĐ",
    type: "Full-time",
    postedBy: "Nguyễn Thị Lan",
    postedTime: "2 giờ trước",
    isHot: true,
    applicants: 34,
  },
  {
    id: 2,
    title: "Sous Chef",
    company: "Khách sạn Intercontinental",
    group: "Nhà hàng & Khách sạn",
    location: "TP.HCM",
    salary: "15-25M VNĐ",
    type: "Full-time",
    postedBy: "Trần Văn Minh",
    postedTime: "3 giờ trước",
    isHot: true,
    applicants: 52,
  },
  {
    id: 3,
    title: "Kỹ sư QC Thực phẩm",
    company: "Công ty CP Thực phẩm Sài Gòn",
    group: "Chế biến Thực phẩm",
    location: "Đồng Nai",
    salary: "12-20M VNĐ",
    type: "Full-time",
    postedBy: "Lê Hoàng Nam",
    postedTime: "5 giờ trước",
    isHot: false,
    applicants: 28,
  },
];

// Latest Job Posts Data
export const latestJobPosts: Job[] = [
  {
    id: 4,
    title: "Công nhân Lắp ráp",
    company: "Samsung Electronics",
    group: "Điện tử & Linh kiện",
    location: "Bắc Ninh",
    salary: "8-12M VNĐ",
    type: "Full-time",
    postedBy: "Phạm Thu Hà",
    postedTime: "1 ngày trước",
    applicants: 67,
  },
  {
    id: 5,
    title: "Thợ hàn chuyên nghiệp",
    company: "Hyundai Motor",
    group: "Ô tô & Cơ khí",
    location: "Ninh Bình",
    salary: "10-18M VNĐ",
    type: "Full-time",
    postedBy: "Hoàng Văn Dũng",
    postedTime: "1 ngày trước",
    applicants: 45,
  },
];

// Right Sidebar Data - Manufacturing Focus
export const trendingGroups: TrendingGroup[] = [
  {
    name: "Tự động hóa Sản xuất",
    members: "14k",
    growth: "+25%",
    emoji: "🤖",
  },
  {
    name: "An toàn Lao động",
    members: "21k",
    growth: "+18%",
    emoji: "🦺",
  },
  {
    name: "Quản lý Chất lượng",
    members: "18k",
    growth: "+12%",
    emoji: "✅",
  },
  {
    name: "Logistics & Vận tải",
    members: "16k",
    growth: "+15%",
    emoji: "🚛",
  },
];

export const myGroupsActivity: GroupActivity[] = [
  {
    group: "Công nghiệp May mặc",
    activity: "5 việc làm mới",
    time: "2 giờ trước",
    emoji: "👗",
  },
  {
    group: "Nhà hàng & Khách sạn",
    activity: "8 thành viên mới",
    time: "4 giờ trước",
    emoji: "🍽️",
  },
  {
    group: "Ô tô & Cơ khí",
    activity: "Bài viết về an toàn",
    time: "6 giờ trước",
    emoji: "🚗",
  },
];

export const groupRecommendations: GroupRecommendation[] = [
  {
    name: "Dược phẩm & Y tế",
    description: "Sản xuất thuốc và thiết bị y tế",
    members: 12800,
    mutualMembers: 6,
    emoji: "💊",
  },
  {
    name: "Nông nghiệp Công nghệ cao",
    description: "Ứng dụng công nghệ trong nông nghiệp",
    members: 9600,
    mutualMembers: 4,
    emoji: "🌱",
  },
  {
    name: "Năng lượng Tái tạo",
    description: "Sản xuất và phát triển năng lượng xanh",
    members: 11200,
    mutualMembers: 8,
    emoji: "⚡",
  },
];

export const upcomingGroupEvents: GroupEvent[] = [
  {
    title: "Hội thảo May mặc 4.0",
    group: "Công nghiệp May mặc",
    date: "Thứ 6, 29/12",
    time: "14:00",
    attendees: 234,
    type: "Onsite",
  },
  {
    title: "Workshop An toàn Thực phẩm",
    group: "Chế biến Thực phẩm",
    date: "Chủ nhật, 31/12",
    time: "09:00",
    attendees: 156,
    type: "Hybrid",
  },
];

export const groupInsights: GroupInsight[] = [
  { metric: "Nhóm đã tham gia", value: "6", change: "+2 tuần này" },
  { metric: "Bài viết trong nhóm", value: "18", change: "+5 tuần này" },
  { metric: "Kết nối từ nhóm", value: "31", change: "+9 tuần này" },
];

// Helper functions
export const getSuggestedGroups = (groups: Group[], count = 3): Group[] => {
  return groups.filter((group) => !group.isJoined).slice(0, count);
};
